import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/locales/en.json";
import nl from "@/locales/nl.json";

// Strings are bundled at build time (no async loading) so the very first
// paint is already in the right language and Lighthouse / SSR-style
// crawlers don't see a flash of fallback copy.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nl: { translation: nl },
    },
    // Dutch is the primary language of the product and its audience.
    // A browser reporting "nl-NL" (or "en-GB") must resolve to the
    // language-only bundle; without load/nonExplicitSupportedLngs the
    // region code was rejected and every Dutch phone got English.
    fallbackLng: "nl",
    supportedLngs: ["en", "nl"],
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      // Order matters: user's explicit choice wins, then browser, then HTML lang.
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "fa_lang",
      // Normalise "nl-NL" / "en-GB" to the bare language so i18n.language
      // is always "nl" or "en". Date formatting helpers compare against
      // the bare code; with the region attached they fell through to
      // en-US and a Dutch dashboard showed "Thursday, Sep 10".
      convertDetectedLanguage: (lng: string) => lng.split(/[-_]/)[0].toLowerCase(),
    },
  });

// Keep the document language in step so screen readers, hyphenation
// and the :lang() selector follow the active UI language.
const syncDocumentLang = (lng: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng.split("-")[0];
  }
};
syncDocumentLang(i18n.resolvedLanguage ?? i18n.language ?? "nl");
i18n.on("languageChanged", syncDocumentLang);

export default i18n;
